import { Pipe, PipeTransform } from '@angular/core';

import { pacoteCampanhaSituacoes } from '../pacote-campanha-situacao';

@Pipe({
    name: 'pacoteCampanhaSituacao'
})
export class PacoteCampanhaSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = pacoteCampanhaSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return pacoteCampanhaSituacoes[index].nome;
        }
        return '';
    }
}
